
import React from "react";

export default function Footer() {
  return (
    <footer className="bg-brand-900 text-gray-300">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 py-8 sm:py-10 md:py-14">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8 mb-8 sm:mb-10">
          {/* Logo & About */}
          <div className="col-span-2 sm:col-span-2 lg:col-span-2">
            <img
              src="https://vitassoilac.com//storage/settings/June2025/2JbKQzSBb9xQVwQjwEYg.png"
              alt="Vitasso Logo"
              className="h-9 sm:h-10 md:h-12 w-auto mb-3 sm:mb-4"
            />
            <p className="text-[11px] sm:text-xs md:text-sm text-brand-200/70 leading-relaxed mb-4 sm:mb-5 max-w-sm">
              Vitasso, Türkiye&apos;nin en yenilikçi Mineral, Vitamin ve Probiyotik
              markasıdır. 0-16 yaş arası çocuklar ve aileler için organik takviye
              gıda ürünleri sunmaktadır.
            </p>
            <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5">
              <a
                href="https://www.facebook.com/vitassoilac/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 sm:w-9 sm:h-9 bg-brand-800 rounded-full flex items-center justify-center hover:bg-brand-600 transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-facebook-fill text-xs sm:text-sm"></i>
                </div>
              </a>
              <a
                href="https://www.instagram.com/vitassoilacturkiye/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-8 h-8 sm:w-9 sm:h-9 bg-brand-800 rounded-full flex items-center justify-center hover:bg-brand-600 transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line text-xs sm:text-sm"></i>
                </div>
              </a>
            </div>
            <p className="text-[9px] sm:text-[10px] md:text-xs text-brand-300/50 hidden sm:block">
              Organik Takviye Ürünleri &bull; Çocuk Vitamini ve Mineralleri &bull;
              Magnezyum Damla &bull; Probiyotik Takviyesi
            </p>
          </div>

          {/* Kategoriler */}
          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-xs sm:text-sm">
              Kategoriler
            </h4>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm">
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Tüm Ürünler
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
                >
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-price-tag-3-line text-[10px] text-brand-400"></i>
                  </div>
                  Yeni Ürünler
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
                >
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-discount-percent-line text-[10px] text-amber-400"></i>
                  </div>
                  Fırsat Ürünleri
                </a>
              </li>
            </ul>
          </div>

          {/* Kurumsal */}
          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-xs sm:text-sm">
              Kurumsal
            </h4>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm">
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Hakkımızda
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Teslimat Şartları
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  KVKK
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Gizlilik
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  İade Şartları
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div className="col-span-2 sm:col-span-1">
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-xs sm:text-sm">
              İletişim
            </h4>
            <ul className="space-y-2.5 sm:space-y-3.5 text-xs sm:text-sm">
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-brand-400 text-xs sm:text-sm"></i>
                </div>
                <p className="text-brand-200/70 text-[10px] sm:text-xs leading-relaxed">
                  Batıkent Ticaret Merkezi<br />
                  Yazır Mah. Öztopraklar Sok.<br />
                  No: 13/305 Selçuklu / KONYA
                </p>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-brand-400 text-xs sm:text-sm"></i>
                </div>
                <a
                  href="tel:+905449793051"
                  className="hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap text-xs sm:text-sm"
                >
                  0 544 979 3051
                </a>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-brand-400 text-xs sm:text-sm"></i>
                </div>
                <a
                  href="mailto:info@vitassoilac.com"
                  className="hover:text-brand-300 transition-colors cursor-pointer text-xs sm:text-sm break-all"
                >
                  info@vitassoilac.com
                </a>
              </li>
            </ul>

            {/* Güven Rozetleri */}
            <div className="mt-4 sm:mt-6 flex items-center gap-3">
              <div className="bg-brand-800/60 rounded-lg px-2.5 sm:px-3 py-1.5 sm:py-2 flex items-center gap-1.5 sm:gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-fill text-brand-400 text-xs sm:text-sm"></i>
                </div>
                <span className="text-[9px] sm:text-[10px] text-brand-200/80 font-medium">
                  Güvenli Alışveriş
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Ödeme Yöntemleri */}
        <div className="border-t border-brand-800 pt-4 sm:pt-6 mb-4 sm:mb-6">
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 md:gap-4">
            <div className="flex items-center gap-1.5 sm:gap-2 bg-brand-800/40 rounded-lg px-2 sm:px-3 py-1.5 sm:py-2">
              <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex items-center justify-center">
                <i className="ri-truck-line text-brand-400 text-[10px] sm:text-sm"></i>
              </div>
              <span className="text-[9px] sm:text-[10px] md:text-xs text-brand-200/70">
                Hızlı Teslimat
              </span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2 bg-brand-800/40 rounded-lg px-2 sm:px-3 py-1.5 sm:py-2">
              <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-brand-400 text-[10px] sm:text-sm"></i>
              </div>
              <span className="text-[9px] sm:text-[10px] md:text-xs text-brand-200/70">
                Orijinal Ürünler
              </span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2 bg-brand-800/40 rounded-lg px-2 sm:px-3 py-1.5 sm:py-2">
              <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-brand-400 text-[10px] sm:text-sm"></i>
              </div>
              <span className="text-[9px] sm:text-[10px] md:text-xs text-brand-200/70">
                7/24 Destek
              </span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2 bg-brand-800/40 rounded-lg px-2 sm:px-3 py-1.5 sm:py-2">
              <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex items-center justify-center">
                <i className="ri-bank-card-line text-brand-400 text-[10px] sm:text-sm"></i>
              </div>
              <span className="text-[9px] sm:text-[10px] md:text-xs text-brand-200/70">
                Güvenli Ödeme
              </span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2 bg-brand-800/40 rounded-lg px-2 sm:px-3 py-1.5 sm:py-2">
              <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex items-center justify-center">
                <i className="ri-gift-line text-brand-400 text-[10px] sm:text-sm"></i>
              </div>
              <span className="text-[9px] sm:text-[10px] md:text-xs text-brand-200/70">
                Kampanyalar
              </span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-brand-800 pt-4 sm:pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
            <p className="text-[10px] sm:text-xs text-brand-300/50 text-center sm:text-left">
              &copy; 2026 Vitasso Organik Takviye Ürünleri. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] sm:text-xs text-brand-300/50 hover:text-brand-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                Mahzen Creative
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
